'use strict';
export default angular.module('toggleClass', [], function () { })
    .controller('ToggleClassController', function ($scope) {
    $scope.message = "Welcome";
})
    .directive('toggleClass', function ($document) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            function elementClick(e) {
                e.stopPropagation();
                element.parent().removeClass(attrs.toggleClass);
            }
            function documentClick(e) {
                element.parent().removeClass(attrs.toggleClass);
                //element.getElementsByClassName("track-order-wrapper").removeClass('md-open');
                // element.parent().children().addClass('ng-hide');
                // element.removeClass('ng-hide');
            }
            element.on('click', elementClick);
            $document.on('click', documentClick);
            // remove event handlers when directive is destroyed
            scope.$on('$destroy', function () {
                console.log('out');
                element.off('click', elementClick);
                $document.off('click', documentClick);
            });
        }
    };
})
    .name;
//# sourceMappingURL=toggleClass.js.map